import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import UIBackButton from 'UIComponents/nav/UIBackButton';
import UILink from 'UIComponents/link/UILink';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import UIButton from 'UIComponents/button/UIButton';
import H5 from 'UIComponents/elements/headings/H5';
import UIExpandableText from 'UIComponents/text/UIExpandableText';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
// @ts-expect-error migrate dependency
import ConnectReferenceResolvers from 'reference-resolvers/ConnectReferenceResolvers';
// @ts-expect-error migrate dependency
import FilterOperatorRefinableInput from 'customer-data-filters/components/operator/FilterOperatorRefinableInput';
// @ts-expect-error migrate dependency

import FilterOperatorErrorRecord from 'customer-data-filters/filterQueryFormat/FilterOperatorErrorRecord';
import { getOperatorLabel, getPlaceholder, getPropertyFieldDefinitions
// @ts-expect-error migrate dependency
} from 'reporting-snowflake/relational/modify/filters/xo-filter-utils';
// @ts-expect-error migrate dependency
import { selectUserId, selectAllGates } from 'dashboard-lib/public/userInfo';
import { getInputComponent, getSharedFilterOperatorProps } from 'platform-dashboard-ui/filter/utils/filterEditorUtils';
import { getDefaultOperatorForProperty } from 'platform-dashboard-ui/filter/utils/dataSourceHelpers';
import { getDescription, getLabel, getName, getType
// @ts-expect-error migrate dependency
} from '../../../../../lib/dashboardFilters/propertySchema';
import { getDashboardFilterOperators, getIsUngated } from '../../../../../lib/dashboardFilters/getDashboardFilterOperators';
import { useCurrencyCode } from '../../../../../lib/dashboardFilters/useCurrencyCode';
import PinnedPropertyFilterInputFooter from '../../quickFilters/PinnedPropertyFilterInputFooter';
import { isListMembershipProperty } from 'platform-dashboard-ui/filter/utils/listMembershipFilterUtils';
import { ListMembershipOperatorInput } from './ListMembershipOperatorInput';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { REPORTING_LEGACY_OPERATOR_USAGE } from '../../../../../constants/Metrics';
import { Metrics } from '../../../../../lib/Metrics';
import { validateFilterOperator } from 'platform-dashboard-ui/filter/utils/filterEditorUtils';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const NO_ERROR = FilterOperatorErrorRecord({
  error: false
});
const DashboardFilterOperatorInput = ({
  dataSource,
  onApplyFilter,
  onNavigateBack,
  property,
  prevOperator = null,
  onChangeFilter = () => {},
  isQuickFilterInput = false,
  userHasQuickFilterEditPermission = false,
  resolvers,
  dashboardId
}) => {
  const userId = useSelector(selectUserId);
  const propertyType = getType(property);
  const propertyName = getName(property);
  const currencyCode = useCurrencyCode();
  const gates = useSelector(selectAllGates);
  const [selectedOperator, setSelectedOperator] = useState(prevOperator || getDefaultOperatorForProperty(dataSource, property));
  const {
    isValid,
    message: operatorValidationMessage
  } = validateFilterOperator(selectedOperator);
  const handleChange = ({
    target: {
      value
    }
  }) => {
    setSelectedOperator(value);
  };
  const handleApplyFilter = () => {
    onApplyFilter(selectedOperator);
  };
  useEffect(() => {
    Metrics.counter(REPORTING_LEGACY_OPERATOR_USAGE, {
      type: 'filter-operator'
    }).increment();
  }, []);
  if (!currencyCode) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered"
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!isQuickFilterInput && /*#__PURE__*/_jsx(UIBackButton, {
      "data-test-id": "back-to-properties-button",
      children: /*#__PURE__*/_jsx(UILink, {
        onClick: onNavigateBack,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFilters.FilterEditorPanel.back"
        })
      })
    }), /*#__PURE__*/_jsxs(ScrollContainer, {
      maxHeight: "100%",
      children: [/*#__PURE__*/_jsxs(H5, {
        className: "m-bottom-0",
        children: [getLabel(property), prevOperator && !isQuickFilterInput && /*#__PURE__*/_jsx(UIIconButton, {
          className: "p-left-2",
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "dashboardHeader.dashboardFilters.allFilters.panel.changeProperty"
          }),
          use: "link",
          placement: "right",
          onClick: onChangeFilter,
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: "edit"
          })
        })]
      }), /*#__PURE__*/_jsx(UIExpandableText, {
        className: "m-bottom-3",
        children: /*#__PURE__*/_jsx(Text, {
          as: "p",
          marginBlockEnd: "0",
          children: getDescription(property)
        })
      }), isListMembershipProperty(propertyName) ? /*#__PURE__*/_jsx(ListMembershipOperatorInput, {
        dataSource: dataSource,
        property: property,
        selectedOperator: selectedOperator,
        onChange: handleChange,
        resolvers: resolvers
      }) : /*#__PURE__*/_jsx(FilterOperatorRefinableInput, Object.assign({
        error: NO_ERROR,
        fieldDefinitions: getPropertyFieldDefinitions(),
        getDefaultTimezone: () => I18n.moment.portalTz().tz(),
        getFilterFamilyObjectName: () => '',
        getInputComponent: () => getInputComponent(dataSource, property, selectedOperator),
        getIsUngated: getIsUngated(gates),
        getObjectPropertyLabel: () => '',
        getOperatorLabel: getOperatorLabel,
        getOperators: () => getDashboardFilterOperators({
          propertyName,
          propertyType,
          dataSource
        }),
        getPlaceholder: () => getPlaceholder(selectedOperator),
        isFiscalYearEnabled: true,
        isNotUsingTimePoints: true,
        isRollingDateOffsetInputEnabled: false,
        onChange: handleChange,
        showIncludeUnknownValues: false,
        value: selectedOperator
      }, getSharedFilterOperatorProps({
        currencyCode,
        dataSource,
        property,
        resolvers,
        userId,
        gates
      })))]
    }), isQuickFilterInput ? /*#__PURE__*/_jsx(PinnedPropertyFilterInputFooter, {
      onApplyFilter: handleApplyFilter,
      dataSource: dataSource,
      property: property,
      userHasQuickFilterEditPermission: userHasQuickFilterEditPermission,
      dashboardId: dashboardId,
      isValid: isValid
    }) : /*#__PURE__*/_jsx(View, {
      marginBlockStart: "300",
      as: "footer",
      children: /*#__PURE__*/_jsx(UITooltip, {
        title: operatorValidationMessage,
        children: /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "apply-filter-button",
          disabled: !isValid,
          onClick: handleApplyFilter,
          size: "small",
          type: "submit",
          use: "tertiary",
          children: prevOperator ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.FilterEditorOperatorEdit.save"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.FilterEditorOperatorCreate.save"
          })
        })
      })
    })]
  });
};
export default ConnectReferenceResolvers(resolvers => ({
  resolvers
}))(DashboardFilterOperatorInput);